import React, { useState } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton
} from "@mui/material";

import { Close, CheckCircleOutline } from "@mui/icons-material";

import useFirebaseContext from "@/hooks/useFirebaseAuth";

import ReportForm from "./ReportForm";

interface ReportDialogProps {
  open: boolean;
  onClose: () => void;
  reportedUserId: string;
}

const ReportDialog: React.FC<ReportDialogProps> = ({
  open,
  onClose,
  reportedUserId,
}) => {
  const { user } = useFirebaseContext();
  const [success, setSuccess] = useState(false);

  const handleClose = () => {
    setSuccess(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={handleClose}
    >
      <DialogTitle>
        Report User
        <IconButton
          aria-label="Close report dialog"
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: -24,
            right: -24,
            color: "common.white",
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      {success ? (
        <DialogContent>
          <CheckCircleOutline
            sx={{
              fontSize: 64,
              color: "success.main",
              margin: "0 auto",
              display: "block",
            }}
          />
          <Box sx={{
 textAlign: "center",
py: 6 
}}>
            Thank you for your report. We will review this matter and take appropriate action.
          </Box>
          <Box sx={{
 display: "flex",
justifyContent: "center",
mt: 2 
}}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
              }}
            >
              Close
            </Button>
          </Box>
        </DialogContent>
      ) : (
        <ReportForm 
          setSuccess={setSuccess} 
          reportedUserId={reportedUserId}
          currentUserId={user?.uid || ""}
          onClose={handleClose}
        />
      )}
    </Dialog>
  );
};

export default ReportDialog; 